import React from 'react'

import { theme } from '@acorns/grove'
import { AcornsIcon } from '@acorns/icons'
import styled, { keyframes } from 'styled-components'

import { AI_ASSISTANT_TYPING_DOTS } from 'utils/testing/testIDs'

const TypingContainer = styled.div`
  position: relative;
  padding: 12px 10px;
  background: ${theme.colors.primaryWhite};
  border-radius: 100px;
  width: fit-content;
  display: inline-flex;
  height: 12px;
  margin-top: 15px;
`

const firstDotAnimation = keyframes({
  '0%': { height: '6px', marginTop: '0px' },
  '11%': { height: '4px', marginTop: '2px' },
  '22%': { height: '6px', marginTop: '-6px' },
  '100%': { height: '6px', marginTop: '0px' },
})

const secondDotAnimation = keyframes({
  '0%': { height: '6px', marginTop: '0px' },
  '44%': { height: '4px', marginTop: '2px' },
  '55%': { height: '6px', marginTop: '-6px' },
  '100%': { height: '6px', marginTop: '0px' },
})

const thirdDotAnimation = keyframes({
  '0%': { height: '6px', marginTop: '0px' },
  '77%': { height: '4px', marginTop: '2px' },
  '88%': { height: '6px', marginTop: '-6px' },
  '100%': { height: '6px', marginTop: '0px' },
})

const TypingDot = styled.div`
  width: 6px;
  height: 6px;
  margin: 0 4px;
  border-radius: 100%;
  z-index: 2;
  background-color: ${theme.colors.primarySlate};
`

const MessageContainer = styled.div`
  display: inline-block;
  margin-bottom: 20px;
  padding-left: 20px;
`

const AcornContainer = styled.div`
  width: 40px;
  height: 40px;
  padding: 10px;
  border-radius: 50%;
  background-color: ${theme.colors.primaryGreen};
  display: inline-flex;
  vertical-align: top;
  margin-top: 10px;
`

const Acorn = styled(AcornsIcon)`
  width: 20px;
  height: 20px;
  path {
    fill: ${theme.colors.primaryWhite};
  }
`

const FirstTypingDot = styled(TypingDot)`
  animation: ${firstDotAnimation} 2s linear infinite;
`

const SecondTypingDot = styled(TypingDot)`
  animation: ${secondDotAnimation} 2s linear infinite;
`

const ThirdTypingDot = styled(TypingDot)`
  animation: ${thirdDotAnimation} 2s linear infinite;
`

export const TypingDots = () => (
  <MessageContainer>
    <AcornContainer>
      <Acorn icon={AcornsIcon.Icon.AcornsLogo} />
    </AcornContainer>
    <TypingContainer data-testid={AI_ASSISTANT_TYPING_DOTS}>
      <FirstTypingDot />
      <SecondTypingDot />
      <ThirdTypingDot />
    </TypingContainer>
  </MessageContainer>
)
